import { Component, OnInit } from '@angular/core';
import { FormControl, Validators} from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import { Location } from '@angular/common';
declare var $: any;
import { MatSnackBar } from '@angular/material/snack-bar';
class ImageSnippet {
  constructor(public src: string, public file: File) { }   //image uploading
}

@Component({
  selector: 'app-edit-emloyee',
  templateUrl: './edit-emloyee.component.html',
  styleUrls: ['./edit-emloyee.component.css']
})
export class EditEmloyeeComponent implements OnInit {
  
  creationForm: FormGroup;
  employeeForm : FormGroup

  constructor(private locations :Location ,private employeeService: ServiceService, private route: ActivatedRoute, private router: Router, private formBuilder:FormBuilder,private _snackbar:MatSnackBar) { 
    this.creationForm = this.formBuilder.group({
      workin_time: [''],
      workout_time: [''],
      is_department_specific: [false],
      is_location_restricted: [false],
      weekly_working_days:[[]]
    });
    this.employeeForm = this.formBuilder.group({
      employee_id : [null,Validators.required],
      attendance : [null]
    })
  }

  selectedFile: ImageSnippet | undefined;   //image uploading

  output: any = []; //---store get() result--------
  dept: any = [];
  processedData: any = [];
  finalprocessedData: any = [];
  createemployeeArray: any = [];
  employeeId = '';
  select_Month=""
  select_Month_No=""
  index=0;
  leave_array:any

  public model = Array();
  public model1 = Array();
  minDate= new Date()
  maxDate= new Date()
  calenderShown=false
  DName="*"
  MName="*"
  //getUrl='http://192.241.151.66:5000/viewEmployees';
  //putUrl='http://192.241.151.66:5000/updateEmployees';
  //deptUrl='http://192.241.151.66:5000/viewDepartments/department_dropdown';
  //brandUrl='http://192.241.151.66:5000/viewBrands/brand_dropdown';
  //uploadUrl='http://192.241.151.66:5000/updateEmployees/employee_document'
  data: any = {
    // add_monthly_employee_kpi_value: [],
    // update_monthly_employee_kpi_value: [],
    // delete_monthly_employee_kpi_value: [],
    employee_name: "",
    employee_id: "",
    employee_code: "",
    department: "",
    role: "",
    rfr_kpi: "",
    attendance_kpi: "",
    visit_plan_kpi: "",
    visit_kpi: "",
    daily_kpi: "",
    invoice_target_kpi: "",
    receipt_target_kpi: "",
    projection_kpi: "",
    email_address: "",
    today_visit_target: "",
    current_month_visits_target: "",
    monthly_invoice_target: "",
    monthly_receipts_target: "",
    department_id: "",
    company_brand: "",
    product_brand: "",
    current_year_sales_target: "",
    current_year_receipt_target: "",
    mobile: "",
    default_kpi_value: "",
    agreed_sales_kpi: "",
    agreed_receipts_kpi:"",
    active_qualified_kpi:"",
    active_qualified_percentage:"",
    active_non_qualified_kpi:"",
    avg_no_sales_percentage:"",
    avg_no_sales_kpi:"",
    employee_document: new FormData()
  }
  data1 = {
    month: null,
    rfr_kpi: null,
    // attendance_kpi: null,
    attendance_kpi_late: null,
    attendance_kpi_absent: null,
    visit_plan_kpi: null,
    visit_kpi: null,
    daily_kpi: null,
    invoice_target_kpi: null,
    receipt_target_kpi: null,
    projection_kpi: null,
    _id: null,
    agreed_sales_kpi:null,
    agreed_receipts_kpi:null,
    active_qualified_count:null,
    active_qualified_kpi:null,
    active_leads_count:null,
    active_leads_kpi:null,
    non_qualified_to_qualified_count:null,
    non_qualified_to_qualified_kpi:null,
    overdue_inactive_percentage:null,
    overdue_inactive_kpi:null,
    total_overdue_customer_kpi:null,
    total_overdue_customer_target:null
  }

  leave_data={
    employee_id:null,
    employee_name:null,
    add_leave_management:Array(),
    update_leave_management:Array(),
  
  }

  alert = "";
  department: any = [];
  brand: any = [];
  TempBrand: any = [];
  TempDept: any = [];
  isShown: boolean = false;
  currentInput = ""
  message = ""
  imageUrl = ""
  monthlyemployeeArray :any = []
  public img: any = "";
  name = ""
  url = this.employeeService.ReturnBase();
  EmailAlert = ""
  DeptCount = 0;
  BrandCount = 0;

  email: any = new FormControl('', [Validators.required, Validators.email]);
  Month=[{name:"January",id:"01",last:31},
  {name:"February",id:"02",last:28},
  {name:"March",id:"03",last:31},
  {name:"April",id:"04",last:30},
  {name:"May",id:"05",last:31},
  {name:"June",id:"06",last:30},
  {name:"July",id:"07",last:31},
  {name:"August",id:"08",last:31},
  {name:"September",id:"09",last:30},
  {name:"October",id:"10",last:31},
  {name:"November",id:"11",last:30},
  {name:"December",id:"12",last:31},
 ]
  year = new Date();
  current_year=this.year.getFullYear()
 
  update_Id=null;

  //for showing notifivation

  //-------function for year selection-----
  YearSelected(value:any){
     this.current_year=value
     console.log("year=",this.current_year)
     this.CheckMonth(this.select_Month+" "+this.current_year)
  }

  MonthSelected(value:any){
    this.model=[];
    this.model1=[];
    this.MName="*";
   
   
   
    var month=this.Month[value].id
  
   

    //---------set max and min for calender-------
    var start=this.Month[value].id+"/"+"1"+"/"+this.current_year
    var end=this.Month[value].id+"/"+this.Month[value].last+"/"+this.current_year
    console.log("start=", end)
    this.minDate= new Date(start)
    this.maxDate= new Date(end)
    this.calenderShown=true

    this.select_Month=this.Month[value].name
    this.select_Month_No=this.Month[value].id

    this.CheckMonth(this.select_Month+" "+this.current_year)
    console.log("Month=",this.select_Month )



  }
  CheckMonth(Month:any){

    this.update_Id=null;
    const index = this.leave_array.findIndex((item: { month_year: any; }) => item.month_year === Month);
    console.log("index=",this.index)
    if(index !== -1){
       console.log("present")
       var temp_date_array1=[]
       var temp_date_array2=[]
       for(var i=0;i<this.leave_array[index].vacation_days.length;i++){

        temp_date_array1.push(new Date(this.leave_array[index].vacation_days[i]))
       // temp_date_array2.push(new Date(this.leave_array[index].sick_leave_days[i]))
       }
       for(var i=0;i<this.leave_array[index].sick_leave_days.length;i++){

       // temp_date_array1.push(new Date(this.leave_array[index].vacation_days[i]))
        temp_date_array2.push(new Date(this.leave_array[index].sick_leave_days[i]))
       }
       this.model =temp_date_array1
       this.model1 =temp_date_array2
       this.update_Id=this.leave_array[index]._id
       console.log("this.model",this.model)

    
    }
  }

  //-----function or submit leave------
  SubmitLeave(){

    var status=false
    console.log("Month=",this.select_Month)

    console.log("Model=",this.model)
    console.log("Model1",this.model1)
    if(this.select_Month==""){
      this.MName="Select a month"
      status=true
    }
    if( status){
      return
    }
 

    this.leave_data.add_leave_management=[]
    this.leave_data.update_leave_management=[]
    console.log("this.update_Id",this.update_Id)

    if(this.update_Id==null){

      var obj={
          month:this.current_year+"-"+this.select_Month_No,
          vacation_days:this.model,
          sick_leave_days:this.model1
       }
      this.leave_data.add_leave_management.push(obj)
    }
    else{
      var obj1={
        _id:this.update_Id,
        vacation_days:this.model,
        sick_leave_days:this.model1
     }
    this.leave_data.update_leave_management.push(obj1)
    }

    console.log("leave dates=",this.leave_data)
    //return;
    //--------api for put----------//
    this.employeeService.UpdateEmployee(this.leave_data).subscribe((res) => {
      console.log("name=", this.data.name);
      this.alert = res.message;
      console.log("res=", this.alert);
      this.ngOnInit();
      this.router.navigateByUrl(('admin/employee-details')); 
    
    })
  }
  notification() {
    this.isShown = !this.isShown;
  }

  //--------function for shown the alert----------
  shown() {
    this.isShown = false
  }

  //for getting id of selected department
  onSelected(value: string): void {
    this.data.department_id = value;

    //-------api get()calling for dept name of carrasponding id-------------
    this.employeeService.ViewDepartment('/' + value).subscribe((res) => {
      this.dept = res.data;
      this.data.department = this.dept[0].department_name;
      console.log("dept after=", this.data.department_id);
      console.log("dept after=", this.dept[0].department_name);
    })
  }
  //---------check value changes in the text box----
  valuechange1(newValue1: any) {
    this.data.name = newValue1
    this.EmailAlert = ""
  }

  saveFirst(monthlyemployeeArray: any) {
    this.processedData = []; // Create an array to store processed data

    for (let i = 0; i < monthlyemployeeArray.length; i++) {
      const processedObj = {
        month: monthlyemployeeArray[i].month,
        rfr_kpi: monthlyemployeeArray[i].rfr_kpi,
        // attendance_kpi: monthlyemployeeArray[i].attendance_kpi,
        attendance_kpi_late: monthlyemployeeArray[i].attendance_kpi_late,
        attendance_kpi_absent: monthlyemployeeArray[i].attendance_kpi_absent,
        visit_plan_kpi: monthlyemployeeArray[i].visit_plan_kpi,
        visit_kpi: monthlyemployeeArray[i].visit_kpi,
        daily_kpi: monthlyemployeeArray[i].daily_kpi,
        invoice_target_kpi: monthlyemployeeArray[i].invoice_target_kpi,
        receipt_target_kpi: monthlyemployeeArray[i].receipt_target_kpi,
        projection_kpi: monthlyemployeeArray[i].projection_kpi,
        _id: monthlyemployeeArray[i]._id,
        active_qualified_percentage:monthlyemployeeArray[i].active_qualified_percentage,
        active_qualified_kpi:monthlyemployeeArray[i].active_qualified_kpi,
        active_non_qualified_percentage:monthlyemployeeArray[i].active_non_qualified_percentage,
        active_non_qualified_kpi:monthlyemployeeArray[i].active_non_qualified_kpi,
        avg_no_sales_percentage:monthlyemployeeArray[i].avg_no_sales_percentage,
        avg_no_sales_kpi:monthlyemployeeArray[i].avg_no_sales_kpi,
        agreed_sales_kpi:monthlyemployeeArray[i].agreed_sales_kpi,
        agreed_receipts_kpi:monthlyemployeeArray[i].agreed_receipts_kpi,
        total_overdue_customer_kpi : monthlyemployeeArray[i].total_overdue_customer_kpi,
        total_overdue_customer_target : monthlyemployeeArray[i].total_overdue_customer_target
      };

      this.processedData.push(processedObj); // Push the processed object into the array
    }

  }
  onMonthChange(i: any) {

    const selectedMonthData = this.processedData[i];


    console.log(selectedMonthData)
    
  }


  


  rfrkpichange2(newValue1: any ,i:number) {
    this.processedData[i].rfr_kpi = newValue1
    console.log(newValue1);
    
  
  }
  attendancekpilatechange2(newValue1: any ,i:number) {
    this.processedData[i].attendance_kpi_late = newValue1
    console.log(newValue1);
    
  
  }
  attendancekpiabsentchange2(newValue1: any ,i:number) {
    this.processedData[i].attendance_kpi_absent = newValue1
    console.log(newValue1);
    
  
  }
  visitplankpichange2(newValue1: any ,i:number) {
    this.processedData[i].visit_plan_kpi = newValue1
    console.log(newValue1);
    
  
  }
  visitkpichange2(newValue1: any ,i:number) {
    this.processedData[i].visit_kpi = newValue1
    console.log(newValue1);
    
  
  }
  dailykpichange2(newValue1: any ,i:number) {
    this.processedData[i].daily_kpi = newValue1
    console.log(newValue1);
    
  
  }
  invoicetargetkpichange2(newValue1: any ,i:number) {
    this.processedData[i].invoice_target_kpi = newValue1
    console.log(newValue1);
    
  
  }
  receipttargetkpichange2(newValue1: any ,i:number) {
    this.processedData[i].receipt_target_kpi = newValue1
    console.log(newValue1);
    
  
  }
  projectionkpichange2(newValue1: any ,i:number) {
    this.processedData[i].projection_kpi = newValue1
    console.log(newValue1);
    
  
  }
  agreedsaleskpichange(newValue1:any, i:number){
    this.processedData[i].agreed_sales_kpi = newValue1
    console.log(newValue1);
    
  }
  agreedreceipkpitchange(newValue1:any, i:number){
    this.processedData[i].agreed_receipts_kpi = newValue1
    console.log(newValue1);
    
  }
  activequalifiedprcgchange(newValue1:any, i:number){
    this.processedData[i].active_qualified_count = newValue1
    console.log(newValue1);
    
  }
  activequalifiedkpichange(newValue1:any, i:number){
    this.processedData[i].active_qualified_kpi = newValue1
    console.log(newValue1);
    
  }
  activeLeadcount(newValue1:any, i:number){
    this.processedData[i].active_leads_count = newValue1
    console.log(newValue1);
    
  }
  activeLeadkpi(newValue1:any, i:number){
    this.processedData[i].active_leads_kpi = newValue1
    console.log(newValue1);
    
  }
  activenoqualifiedprcngchange(newValue1:any, i:number){
    this.processedData[i].non_qualified_to_qualified_count = newValue1
    console.log(newValue1);
    
  }
  activenoqualifiedkpichange(newValue1:any, i:number){
    this.processedData[i].non_qualified_to_qualified_kpi = newValue1
    console.log(newValue1);
    
  }
  averagenonsaleprcngchange(newValue1:any, i:number){
    this.processedData[i].overdue_inactive_percentage = newValue1
    console.log(newValue1);
    
  }
  averagenonsaleskpichange(newValue1:any, i:number){
    this.processedData[i].overdue_inactive_kpi = newValue1
    console.log(newValue1);
    
  }

  updateValue(newValue:any, i:number) {
    this.processedData[i].total_overdue_customer_kpi =newValue;
  }
  updateValue1(newValue:any, i:number) {
    this.processedData[i].total_overdue_customer_target =newValue;
  }



  FinalProcess() {
    this.finalprocessedData = []; // Create an array to store processed data

    for (let i = 0; i < this.processedData.length; i++) {
      const processedObj1 = {
        month: this.processedData[i].month,
        rfr_kpi: this.processedData[i].rfr_kpi,
        // attendance_kpi: this.processedData[i].attendance_kpi,
        attendance_kpi_late: this.processedData[i].attendance_kpi_late,
        attendance_kpi_absent: this.processedData[i].attendance_kpi_absent,
        visit_plan_kpi: this.processedData[i].visit_plan_kpi,
        visit_kpi: this.processedData[i].visit_kpi,
        daily_kpi: this.processedData[i].daily_kpi,
        invoice_target_kpi: this.processedData[i].invoice_target_kpi,
        receipt_target_kpi: this.processedData[i].receipt_target_kpi,
        projection_kpi: this.processedData[i].projection_kpi,
        _id: this.processedData[i]._id,
        active_qualified_count:this.processedData[i].active_qualified_count,
        active_qualified_kpi:this.processedData[i].active_qualified_kpi,
        active_leads_count:this.processedData[i].active_leads_count,
        active_leads_kpi:this.processedData[i].active_leads_kpi,
        non_qualified_to_qualified_count:this.processedData[i].non_qualified_to_qualified_count,
        non_qualified_to_qualified_kpi:this.processedData[i].non_qualified_to_qualified_kpi,
        overdue_inactive_percentage:this.processedData[i].overdue_inactive_percentage,
        overdue_inactive_kpi:this.processedData[i].overdue_inactive_kpi,
        agreed_sales_kpi:this.processedData[i].agreed_sales_kpi,
        agreed_receipts_kpi:this.processedData[i].agreed_receipts_kpi,
        total_overdue_customer_kpi:this.processedData[i].total_overdue_customer_kpi,
        total_overdue_customer_target:this.processedData[i].total_overdue_customer_target

      };

      this.finalprocessedData.push(processedObj1); // Push the processed object into the array
    }
    this.data.update_monthly_employee_kpi_value = this.finalprocessedData
    console.log(this.data.update_monthly_employee_kpi_value )

  }

  getCurrentMonth(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = ((now.getMonth() + 1)-2).toString().padStart(2, '0');
    return `${year}-${month}`;
  }


  KpiSubmit() {
    this.createemployeeArray =[]
    console.log(this.data);

    console.log("hello");
    console.log(this.data1);

    // Push data1 into the add_monthly_employee_kpi_value array
    this.createemployeeArray.push(this.data1);

    console.log(this.createemployeeArray);

    this.data.add_monthly_employee_kpi_value = this.createemployeeArray
    console.log("last=", this.createemployeeArray)


    this.employeeService.UpdateEmployee(this.data).subscribe((res) => {

      console.log("name=", this.data.name);
      this._snackbar.open(res.message, 'ok',{
        duration:4000
      })
      this.alert = res.message;
      console.log("res=", this.alert);
      this.ngOnInit();


    })
   

  }

  btnClick() {


    this.FinalProcess();

    console.log(this.data)

    if (this.data.email_address != " " && this.data.email_address != "") {
      console.log("hai")
      if (this.email.invalid) {
        this.EmailAlert = "invalid email id"
        this.alert = "Invalid data"
        return
      }
    }
    if (this.data.email_address == "") {
      this.data.email_address = " "

      console.log("no email", this.data.email_address)

    }
    console.log(this.data.M_receipt_Target)
    console.log(this.data)
    
   



    //--------api for put----------//
    this.employeeService.UpdateEmployee(this.data).subscribe((res) => {
      console.log("name=", this.data.name);
      this.alert = res.message;
      console.log("res=", this.alert);
      this.ngOnInit();
      this.router.navigateByUrl(('admin/employee-details')); 


    })

  }
  //----------------image uploading---------------------------------
  processFile(imageInput: any) {

    const file: File = imageInput.files[0];
    const reader = new FileReader();
    reader.addEventListener('load', (event: any) => {

      this.selectedFile = new ImageSnippet(event.target.result, file);
      const formData = new FormData();
      formData.append('employee_id', this.employeeId);
      formData.append('employee_document', this.selectedFile.file);

      this.name = this.selectedFile.file.name
      this.currentInput = this.selectedFile.file.name

      this.employeeService.UploadEmpDocument(formData).subscribe((res) => {
        this.message = res.message
        //this.imageUrl=res.data
        console.log("Message=", this.message)

      })
    });

    reader.readAsDataURL(file);
  }
  //----------------remove image---------------------------------
  RemoveFile() {

    const formData = new FormData();
    formData.append('employee_id', this.employeeId);
    formData.append('employee_document', "");
    console.log("eid=", this.employeeId)

    this.employeeService.UploadEmpDocument(formData).subscribe((res) => {
      this.message = res.message
      console.log("Messagess=", this.message)
    })


  }

  //-----------------------------------------------------------------
addKpi():void{
  this.resetForm();

     $('#modal-sm3').modal({
      backdrop: false
    });
    $('#modal-sm3').modal('show')
}
resetForm(): void {
  // Reset your form data here
  this.data1 = {
    month: null,
    rfr_kpi: null,
    // attendance_kpi: null,
    attendance_kpi_late: null,
    attendance_kpi_absent: null,
    visit_plan_kpi: null,
    visit_kpi: null,
    daily_kpi: null,
    invoice_target_kpi: null,
    receipt_target_kpi: null,
    projection_kpi: null,
    _id: null,
    agreed_sales_kpi:null,
    agreed_receipts_kpi:null,
    active_qualified_count:null,
    active_qualified_kpi:null,
    active_leads_count:null,
    active_leads_kpi:null,
    non_qualified_to_qualified_count:null,
    non_qualified_to_qualified_kpi:null,
    overdue_inactive_percentage:null,
    overdue_inactive_kpi:null,
    total_overdue_customer_kpi:null,
    total_overdue_customer_target:null
  };
}
  ngOnInit(): void {
    // $('#modal-sm3').modal({
    //   backdrop: false
    // });
    //---call function in service for employee Id------
    this.employeeId = this.employeeService.getEmployeeId()
    console.log("employee id=", this.employeeId)

    //-------api get()calling-------------
    this.getEditdata(this.employeeId)
    this.employeeService.ViewEmployeeById('/' + this.employeeId).subscribe((res) => {
      this.output = res.data
      // debugger
      console.log("res", this.output)

      this.data = {
        employee_name: this.output[0].employee_name,
        employee_id: this.output[0].employee_id,
        employee_code: this.output[0].employee_code,
        department: this.output[0].department,
        role: this.output[0].role,
        email_address: this.output[0].email_address,
        today_visit_target: this.output[0].today_visit_target,
        current_month_visits_target: this.output[0].current_month_visits_target,
        monthly_invoice_target: this.output[0].monthly_invoice_target,
        monthly_receipts_target: this.output[0].monthly_receipts_target,
        department_id: this.output[0].department_id,
        company_brand: this.output[0].company_brand,
        product_brand: this.output[0].product_brand,
        current_year_sales_target: this.output[0].current_year_sales_target,
        current_year_receipt_target: this.output[0].current_year_receipt_target,
        mobile: this.output[0].mobile,
        default_kpi_value: this.output[0].default_kpi_value,
        rfr_kpi: this.output[0].rfr_kpi,
        // attendance_kpi: this.output[0].attendance_kpi,
        attendance_kpi_late: this.output[0].attendance_kpi_late,
        attendance_kpi_absent: this.output[0].attendance_kpi_absent,
        visit_plan_kpi: this.output[0].visit_plan_kpi,
        visit_kpi: this.output[0].visit_kpi,
        daily_kpi: this.output[0].daily_kpi,
        invoice_target_kpi: this.output[0].invoice_target_kpi,
        receipt_target_kpi: this.output[0].receipt_target_kpi,
        projection_kpi: this.output[0].projection_kpi,

      }
      this.monthlyemployeeArray = this.output[0].monthly_employee_kpi_models,
      console.log("monthlyemployeeArray",this.monthlyemployeeArray)
        this.saveFirst(this.monthlyemployeeArray)
      this.name = this.output[0].employee_document
      this.url = this.url + this.name
      console.log("image file link", this.currentInput)
      console.log(" this.output[0].monthly_employee_kpi_models,", this.output[0].monthly_employee_kpi_models)

      this.leave_data.employee_id=this.output[0].employee_id
      this.leave_data.employee_name=this.output[0].employee_name
      this.leave_array=this.output[0].leave_management_models
      /*----------------------------------------------------------------------------------
      this.employeeService.loginImg(this.url).subscribe(result => {
        this.img = result;
        console.log("my image=",this.img)
      });*/
      //----------------------------------------------------------------------------------------

    })

    //-------api for get department name---------
    this.employeeService.ViewDepartment("").subscribe((res) => {
      this.department = res.data
      console.log("Department details at employee edit =", this.department.length)
    })

    //-------api for get brand name---------
    this.employeeService.BrandDropdown().subscribe((res) => {
      this.brand = res.data
      this.TempBrand = this.brand

      /*
      while(this.){
    
        this.BrandCount=this.BrandCount+1;
        this.employeeService.getData(this.brandUrl+'?offset='+this.BrandCount+'&limit=20').subscribe((res)=>{
        this.TempBrand=res.data
        this.brand=this.brand.concat(this.TempBrand)
        console.log("bLength=",this.TempBrand.length)
        })
  
      }
  */
    })
  }

  selectedDepartmen(value:any){
    console.log("value",value)
    var values = value.split(',');
    console.log('value0',values[0])
    console.log('value1',values[1])
    this.data.department = values[0]
    this.data.department_id = values[1]
    console.log("full data",this.data)
  }



  // attendance managemnet

  weeKDays = [
    {
      week: 'Sunday',
      value: 1,
      checked:false
    },
    {
      week: 'Monday',
      value: 2,
      checked:false
    },
    {
      week: 'Tuesday',
      value: 3,
      checked:false
    },
    {
      week: 'Wednesday',
      value: 4,
      checked:false
    },
    {
      week: 'Thursday',
      value: 5,
      checked:false
    },
    {
      week: 'Friday',
      value: 6,
      checked:false
    },
    {
      week: 'Saturday',
      value: 7,
      checked:false
    },
  ];
  selectedWeek: any = [];
  weekSelected(value: any) {
    if (this.selectedWeek.includes(value)) {
      const index = this.selectedWeek.indexOf(value);
      if (index > -1) {
        this.selectedWeek.splice(index, 1);
      }
    } else {
      this.selectedWeek.push(value);
    }
    console.log(this.selectedWeek);
  }

  getEditdata(id: string) {
    this.employeeService.ViewEmployeeById('/' + id).subscribe({
      next: (value) => {
        console.log(value);
        // debugger
        this.employeeForm.patchValue({
          employee_id : value.data[0]._id 
        })
        this.creationForm.patchValue({
          workin_time: value.data[0]?.workin_time,
          workout_time: value.data[0]?.workout_time,
          is_department_specific: value.data[0]?.is_department_specific,
          is_location_restricted: value.data[0]?.is_location_restricted,
          weekly_working_days: value.data[0]?.weekly_working_days
        });
        if (value.data[0] && 'weekly_working_days' in value.data[0]) {
          this.selectedWeek = value.data[0].weekly_working_days;
        } else {
          this.selectedWeek = []; 
        }
        
        // this.selectedWeek = value.data[0]?.weekly_working_days
        this.creationForm.addControl(
          'employee_id',
          this.formBuilder.control(value.data[0].employee_id)
         );
        console.log(this.creationForm.value);
        
        let workingDays = this.creationForm.controls['weekly_working_days'].value;
        this.weeKDays.forEach(day => {
          day.checked = workingDays.includes(day.value);
        })
        console.log('working',this.weeKDays);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  submitAttendance(){
    if(this.employeeForm.valid){
      this.creationForm.patchValue({
        weekly_working_days : this.selectedWeek
      })

      this.employeeForm.patchValue({
        attendance : this.creationForm.value
      })
      console.log("form valid",this.creationForm.value);
      console.log("form valid 1",this.employeeForm.value);
      this.employeeService.UpdateEmployee(this.creationForm.value).subscribe((res)=>{
        console.log("res",res);
        if(res.success){
          this.employeeService.showToast('success',res.message)
          // this.getEditdata(this.employeeId)
          // this.locations.back()
        }else{
          this.employeeService.showToast('error',res.message)
        }
      })
      
    }else{
      console.log("form invalid");
      this.employeeService.showToast('error','Invalid Form')      
    }
  }




}
